<template>
	<div>
		<p>BID AMOUNTS ARE NOW SET TO SUIT OUR BIDDING INCREMENTS</p>
		<div class="form">
			<input type="text" name="bid" value="" autocomplete="off" v-model="bid" v-on:focus="bid=''" v-on:input="debounceInputBid()" />
			<button type="button" v-on:click="submitBid()">Place Bid</button>
		</div>
		<template v-if="working_placed_bid > 0">
			<h3>You have placed a bid of {{ this.format_currency(working_placed_bid) }}</h3>
		</template>
		<template v-if="working_basket_bid > 0">
			<h3>You have a bid of {{ this.format_currency(working_basket_bid) }} in your bid basket</h3>
		</template>
	</div>
</template>
<script>
import debounce from '../debounce.js';
import { mapGetters, mapActions } from 'vuex';

export default {

	directives: { debounce },
	
	props: [
		'auction_slug',
		'lot_slug',
		'basket_bid',
		'placed_bid'
	],
  
	data: () => {
		return {
			bid: 0,
			working_basket_bid: 0,
			working_placed_bid: 0
		}
	},
    mounted() {
		this.working_basket_bid = this.basket_bid;
		this.working_placed_bid = this.placed_bid;
    },
	methods: {
		// Map the Methods from the State Module
		...mapActions(['minicartRefresh','addAlert']),


		debounceInputBid:  debounce(function() {
			this.inputBid();
		},1000),

		inputBid: function () {
			var self = this;
			var round_to_nearest = 1;
			switch (true) {
				case (this.bid == ''):
					return;
					break;
				case (this.bid < 40):
					self.alert('<strong>Sorry!</strong> The minimum bid is £40.', 'danger');
					this.bid = 40;
					return;
					break;
				case (this.bid < 200):
					round_to_nearest = 10;
					break;
				case (this.bid < 500):
					round_to_nearest = 20;
					break;
				case (this.bid < 1000):
					round_to_nearest = 50;
					break;
				case (this.bid < 2000):
					round_to_nearest = 100;
					break;
				case (this.bid < 5000):
					round_to_nearest = 200;
					break;
				default:
					round_to_nearest = 500;
			}
			this.bid = round_to_nearest * Math.floor(this.bid / round_to_nearest);
		},


		submitBid: function() {
			var self = this;

			// validate bid
			if( this.bid <= 0 ) {
				this.alert('<strong>Whoops!</strong> You must enter a bid value', 'danger');
				return false;
			}

			// post the bid to the basket
			axios.post('/post-bid', {
				auction_slug: this.auction_slug,
				lot_slug: this.lot_slug,
				bid: this.bid,
				type: 'ajax'
			}).then((response) => {
				// update the bid counter
				this.$store.commit('updateMinicartRefreshStatus', true);
				self.working_basket_bid = self.bid;
				
				// display popup
				$.alert({
					title: 'Great!',
					content: 'Thank you for your proposed bid  of <b>' + this.format_currency(this.bid) + '</b>. You can finalise your bids in the bid basket',
					buttons: {
						Continue: {
							text: 'Continue Browsing',
							action: function () {
								self.bid = 0;
							}
						},
						Basket: {
							text: 'View Bid Basket',
							btnClass: 'btn-blue',
							action: function () {
								window.location.href = '/basket'
							}
						}
					}
				});

			}).catch(error => {
				this.$store.commit('updateMinicartRefreshStatus', true);
				this.alert('<strong>Whoops!</strong>' + Object.values(error.response.data.errors)[0][0], 'danger' );
			});

		},

		format_currency: function(value){
			return "£" + this.numberWithCommas((Math.round( (Number(value) + 0.0001) * 100 ) / 100).toFixed(2));
		},
		numberWithCommas: function(x) {
			return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
		},

		alert: function(message, type, important = false) {
			this.addAlert({
				alertClass: 'alert-' + type, 
				alertMessage: message, 
				alertImportant: important,
			});
		},

	}
}
</script>